/* Copyright Verge Technologies 2018
 * @file article.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Article page
 */

// Modules
import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { CONTENT_QUERY } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';

const PrivacyPage = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />
      

      <div className="heading-container">
        <h1>Privacy</h1>
        <hr />
      </div>

      <Query query={CONTENT_QUERY} fetchPolicy="cache-and-network" variables={{ slug: "privacy" }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
<div dangerouslySetInnerHTML={{__html: data.getContent.body}} />
            </div>
          );
        }}
      </Query>
      <Footer />
    </div>
  );
};

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/pages/privacy/privacy.page.js